import React from 'react';
import c from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import UserAvatar from '../../../User/Avatar/UserAvatar';
import UserLink from '../../../User/Link/UserLink';
import TextRenderer from '../../../TextRenderer/TextRenderer';
import DescTiptapViewer from '@wix/da-editor-tiptap/pkg/components/Viewer/presets/DeviationDescription';
import s from './DetailsDumb.scss';
const USER_AVATAR_SIZE = 28;
const DetailsDumb = ({ className, title, withAuthorDetails = true, withOwnerDetails = false, author, owner, rightSlot, withDescriptionBlock, description })=>{
    return /*#__PURE__*/ React.createElement(Flex, {
        direction: "column",
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement(Flex, {
        direction: "row",
        alignItems: "stretch"
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left-cell']
    }, withAuthorDetails && /*#__PURE__*/ React.createElement("div", {
        className: s['avatar']
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        user: author,
        size: USER_AVATAR_SIZE
    }))), /*#__PURE__*/ React.createElement("div", {
        className: c(s['two-center-cells'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, title), author && /*#__PURE__*/ React.createElement("div", {
        className: s['username']
    }, withAuthorDetails && /*#__PURE__*/ React.createElement(UserLink, {
        user: author
    }))), /*#__PURE__*/ React.createElement("div", {
        className: s['right-cell']
    }, rightSlot)), withDescriptionBlock && /*#__PURE__*/ React.createElement("div", {
        className: s['description']
    }, description && (typeof description === 'string' ? description : /*#__PURE__*/ React.createElement(TextRenderer, {
        className: s['description-text'],
        textContent: description,
        tipTapViewer: DescTiptapViewer
    }))));
};
DetailsDumb.displayName = 'DetailsDumb';
export default DetailsDumb;

//# sourceMappingURL=DetailsDumb.js.map